import {Navigate, useLocation} from "react-router-dom";
import {activeUser} from "../services/AuthService";
import {Config} from "../config/config";

export interface AuthRouteProps {
    children: JSX.Element
    allowedTo: string[]
};

export const ProtectedElement = ({ children, allowedTo}: AuthRouteProps) => {
    let location = useLocation();
    if (Config.protectionOff) return children
    if (!(activeUser && activeUser.id)) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    console.log(activeUser)

    if (activeUser.role && allowedTo.findIndex((item) => item == activeUser.role?.name) > -1) {
        return children
    } else {
        return <Navigate to="/not-allowed" state={{ from: location }} replace />;
    }

    return children;
};
